// JavaScript Document

/* mokuji List */
function mokujili(callback,append){
var mokujilist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){
				if(json[i].url_o != ""){
					mokujilist = '<div class="swiper-slide"><a href="' + json[i].url_o + '" target="_top">' + '<img src="' + json[i].img + '" alt="' + json[i].name + '"></a></div>';
				} else {
					mokujilist = '';
				}
   				$(append).append(mokujilist);
   			}
		}
    })
};


